/**
 * @generated SignedSource<<18f83d90d08d35826622988187c162f8>>
 * @relayHash d0a86cdbb584e4c3956f1dbc3faee88b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e39e53b6f62a16b044476f6392f68b0779e61b0127b5cbd6694fa4524c80a32e

import type { ConcreteRequest } from 'relay-runtime';
export type ContentDeleteActionType = "DELETE_DRAFT" | "DELETE_DRAFT_IF_BLANK" | "MOVE_TO_TRASH" | "PURGE_FROM_TRASH" | "%future added value";
export type useHandleDeleteCreatedDraftMutation$variables = {
  action: ContentDeleteActionType;
  contentId: string;
};
export type useHandleDeleteCreatedDraftMutation$data = {
  readonly deleteContent: {
    readonly contentId: string;
    readonly wasDeleted: boolean;
  } | null;
};
export type useHandleDeleteCreatedDraftMutation = {
  response: useHandleDeleteCreatedDraftMutation$data;
  variables: useHandleDeleteCreatedDraftMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "action"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "action",
        "variableName": "action"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "DeleteContentResponsePayload",
    "kind": "LinkedField",
    "name": "deleteContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentId"
      },
      {
        "kind": "ScalarField",
        "name": "wasDeleted"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useHandleDeleteCreatedDraftMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useHandleDeleteCreatedDraftMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d0a86cdbb584e4c3956f1dbc3faee88b",
    "id": "e39e53b6f62a16b044476f6392f68b0779e61b0127b5cbd6694fa4524c80a32e",
    "metadata": {},
    "name": "useHandleDeleteCreatedDraftMutation",
    "operationKind": "mutation",
    "text": "mutation useHandleDeleteCreatedDraftMutation($contentId:ID!,$action:ContentDeleteActionType!){deleteContent(contentId:$contentId,action:$action){contentId,wasDeleted}}"
  }
};
})();

(node as any).hash = "ce0469fb9474cc179bf4a91e6558aa3b";

export default node;
